import { render } from "./NavigationMobilePos.vue?vue&type=template&id=3f458906"
import script from "./NavigationMobilePos.vue?vue&type=script&lang=js"
export * from "./NavigationMobilePos.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__